export default __webpack_public_path__ + "static/sphinx-a449b254ab37816bec436e8ec21803de.svg";